export default __webpack_public_path__ + "static/about-bg-cd8207574744f19e434168ae7798fc3c.jpg";